import type { TMessages } from '@/types/TMessages'

export const messages = {
  android: {
    header: 'Мобильное приложение',
    text: 'Ваш личный кабинет всегда под рукой',
    buttonLabel: 'Скачать',
  },
  iOs: {
    buttonLabel: 'Понятно',
    header: 'Установка приложения iOS',
    text: 'Чтобы установить приложение поле.рф:',
    items: [
      { value: 'Откройте поле.рф на вашем телефоне в браузере Safari' },
      { value: 'Нажмите центральную кнопку «Поделиться» в нижнем меню браузера' },
      { value: 'Выберите На экран «Домой»' },
    ],
  },
} satisfies TMessages
